import { render } from "./EditProductGroupView.vue?vue&type=template&id=c4bf89d2"
import script from "./EditProductGroupView.vue?vue&type=script&lang=js"
export * from "./EditProductGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__